<template>
  <div :class="['d-flex', className]">
    <vs-switch
      v-model="input"
      :disabled="disabled"
      :vsValue="val"
      :color="color"
      class="d-flex m-0 mr-1"
      @change="handleChange"
    />
    <slot/>
  </div>
</template>

<script>
export default {
  props: ['value', 'val', 'label', 'className', 'disabled', 'color'],

  data () {
    return {
      input: null,
    }
  },

  watch: {
    input () {
      this.$emit('input', this.input)
    },
    value () {
      this.input = this.value
    },
  },

  created () {
    this.input = this.value
  },

  methods: {
    handleChange (e) {
      this.$emit('change', this.input)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/base/BaseSwitch.vue